// extracted by css-extract-rspack-plugin
module.exports =  {"linkarrow":"Vd8k9","wrapper":"_14DS","lifestyle_wrapper":"kGvBa"};